import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ColumnAlignment } from '@mews/b2b-ui';
import EntityTable from '../../../../entityManagement/components/EntityTable';
import { EntityDeleteButton } from '../../../../entityManagement/components/EntityDeleteButton';
import { getSelectedCategorySelectedFloorResourceIds } from '../../../selectors/resources';
import ResourceEditLink from './ResourceEditLink';
import ResourceCheckbox from './ResourceCheckbox';
import ParentNumber from './ParentNumber';

const mapping = [
    {
        valueKey: 'select',
        title: '',
        columnWidth: '16px',
        render: (id: $TSFixMe) => <ResourceCheckbox id={id} />,
    },
    {
        valueKey: 'name',
        title: <LocalizedText textKey={TextKey.Number} />,
        render: (id: $TSFixMe, { scope }: $TSFixMe) => <ResourceEditLink id={id} scope={scope} />,
    },
    {
        valueKey: 'parent',
        title: <LocalizedText textKey={TextKey.ParentSpace} />,
        render: (id: $TSFixMe) => <ParentNumber id={id} />,
    },
    {
        title: <LocalizedText textKey={TextKey.ActionPlural} />,
        valueKey: 'action',
        render: (id: $TSFixMe, { scope }: $TSFixMe) => <EntityDeleteButton id={id} scope={scope} />,
        columnAlignment: ColumnAlignment.Right,
    },
];

const ResourcesTable = EntityTable({ mapping });

export default connect(
    createStructuredSelector({
        source: getSelectedCategorySelectedFloorResourceIds,
    })
)(ResourcesTable);
